import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  TextField,
  DialogActions,
  Button,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { useDispatch, useSelector } from "react-redux";
import { deleteOrganization } from "../../../../features/organization/orgSlice";
import { useNavigate } from "react-router";
import { dialogStyles } from "../../../../Constants/dialogStyles";
import { inputStyles } from "../../../../Constants/inputStyles";
import {
  deleteButtonStyles,
  secondaryButtonStyles,
} from "../../../../Constants/buttonStyles";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const DeleteOrganizationDialog = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const organization = useSelector((state) => state.organization);
  const { user } = useSelector((state) => state.auth);
  const [orgNameInput, setOrgNameInput] = useState("");
  const [snackbar, setSnackbar] = useState({
    message: "",
    severity: "success",
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const organizationName = organization?.organization?.name || "Organization";

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleConfirmDelete = () => {
    if (orgNameInput === organizationName) {
      const orgId = user?.user?.organization?.["$oid"];
      dispatch(deleteOrganization(orgId));
      setSnackbar({
        message: "Organization deletion request has been sent.",
        severity: "info",
      });
      setSnackbarOpen(true);
      onClose();
      navigate("/");
    } else {
      setSnackbar({
        message: "Organization name mismatch",
        severity: "warning",
      });
      setSnackbarOpen(true);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            ...dialogStyles.dialogRoot,
          },
        }}
      >
        <DialogTitle sx={dialogStyles.dialogTitle}>
          Confirm Deletion
        </DialogTitle>
        <DialogContent sx={{ ...dialogStyles.dialogContent, mt: 2 }}>
          <Typography sx={dialogStyles.dialogContentText}>
            Please type the organization name{" "}
            <strong>{organizationName}</strong> to confirm deletion:
          </Typography>
          <TextField
            value={orgNameInput}
            onChange={(e) => setOrgNameInput(e.target.value)}
            placeholder={organizationName}
            variant="outlined"
            fullWidth
            sx={inputStyles.textField}
          />
        </DialogContent>
        <DialogActions sx={dialogStyles.dialogActions}>
          <Button onClick={onClose} sx={secondaryButtonStyles}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            disabled={orgNameInput !== organizationName}
            sx={deleteButtonStyles}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DeleteOrganizationDialog;
